import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { HELP } from 'constants/pageNames'
import { PATH as ORIG_PATH, PREVIEW_IMAGE_URL } from 'constants/urls'
import { convertBaseUrlToSiteName } from 'utils/stringUtils'
import Header from 'components/Common/Header'
import Breadcrumb from 'components/Help/Breadcrumb'
import Banner from 'components/Help/Banner'
import SearchBar from 'components/Help/SearchBar'
import Footer from 'components/Common/Footer'
import Helmet from 'components/Common/Helmet'
import SidebarContainer from './SidebarContainer'
import { GlobalStyle, Container, Intro, Main } from './index.style'

const Layout = ({ baseUrl, children, currentCategory, title, description }) => {
  const { t } = useTranslation(HELP)
  const PATH = ORIG_PATH(baseUrl)

  const breadcrumbs = [
    { name: t('Home'), url: PATH.HOME_PAGE },
    { name: t('Help Center'), url: `${baseUrl || '/'}` },
    ...(currentCategory
      ? [
          {
            name: currentCategory.abbr,
            url: currentCategory.url,
          },
        ]
      : []),
  ]

  const titleTemplate = t(`title.${convertBaseUrlToSiteName(baseUrl)}`)

  const metaData = {
    title: title ? `${title} - ${titleTemplate}` : titleTemplate,
    description: description || t('description'),
    imageUrl: PREVIEW_IMAGE_URL,
  }

  return (
    <>
      <Helmet metaData={metaData} />
      <GlobalStyle />
      <Header isHelp baseUrl={baseUrl} />
      <Container>
        <Breadcrumb breadcrumbs={breadcrumbs} />
        <Banner />
        <Intro>{t('Need help?')}</Intro>
        <Main>
          <SearchBar baseUrl={baseUrl} />
          {children}
        </Main>
      </Container>
      <Footer baseUrl={baseUrl} />
    </>
  )
}

Layout.propTypes = {
  baseUrl: PropTypes.string,
  currentCategory: PropTypes.shape({
    abbr: PropTypes.string,
    url: PropTypes.string,
  }),
  title: PropTypes.string,
  description: PropTypes.string,
  children: PropTypes.node,
}

export default Layout

export const LayoutWithSidebar = ({ children, baseUrl, ...props }) => (
  <Layout baseUrl={baseUrl} {...props}>
    <SidebarContainer baseUrl={baseUrl}>{children}</SidebarContainer>
  </Layout>
)

LayoutWithSidebar.propTypes = {
  baseUrl: PropTypes.string,
  children: PropTypes.node,
}
